
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 140571"}},[_c('path',{attrs:{"data-name":"Path 151100","d":"M12.695 6.916a.63.63 0 000-.917.662.662 0 00-.945-.023L8 9.532 4.25 5.976a.662.662 0 00-.944.028.63.63 0 000 .917l4.222 4a.651.651 0 00.472.194.651.651 0 00.472-.194z","fill":"#fff"}})])])
          )
        }
      }
    